/**
 * @generated SignedSource<<7b6f7794cfa0ef38c7c63e5cbff6b5c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserDeletionConfirmModalDeleteInstanceMutation$variables = {
  reason: string;
};
export type UserDeletionConfirmModalDeleteInstanceMutation$data = {
  readonly scheduleUserDeletion: {
    readonly error: {
      readonly message: string | null;
    } | null;
  } | null;
};
export type UserDeletionConfirmModalDeleteInstanceMutation = {
  response: UserDeletionConfirmModalDeleteInstanceMutation$data;
  variables: UserDeletionConfirmModalDeleteInstanceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "reason"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "reason",
    "variableName": "reason"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserDeletionConfirmModalDeleteInstanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ScheduleUserDeletion",
        "kind": "LinkedField",
        "name": "scheduleUserDeletion",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "error",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserDeletionConfirmModalDeleteInstanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ScheduleUserDeletion",
        "kind": "LinkedField",
        "name": "scheduleUserDeletion",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "error",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e7af881ed24c8ce64bf3b0e8e5f0e26d",
    "id": null,
    "metadata": {},
    "name": "UserDeletionConfirmModalDeleteInstanceMutation",
    "operationKind": "mutation",
    "text": "mutation UserDeletionConfirmModalDeleteInstanceMutation(\n  $reason: String!\n) {\n  scheduleUserDeletion(reason: $reason) {\n    error {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "acdedf2a1eeefa8f2dd45cba8bc46136";

export default node;
